import { PIN_BOX, MAXIMIZE_BOX, MINIMIZE_BOX, SELECT_BOX } from "../../plugins/box-widget/store.functions";
import { GridHostComponents } from "./components";
import { createGridItemGetter, createGridLayout } from "../../store/global/gridlayout";

const matchMobile = "only screen and (max-width: 700px)";

// State should be out of Store


export const createGridHost = ({
  layoutName = 'gridLayout',
  gridRef = 'gridLayout'
}) => {
  return {
    components: {
      ...GridHostComponents
    },
    mounted: function () {
      window.onresize = this.windowResizeHandler;
      if (!this.$refs['gridPage']) {
        console.error('Define the Page Component with Ref gridPage');
      }
      // console.log({"this.$refs[gridRef]": this.$refs['gridPage']});

      setTimeout(() => {

        const scrollBarWidth = this.$refs['gridPage'].offsetWidth - this.$refs['gridPage'].clientWidth;

        console.log({ "scrollBarWidth": scrollBarWidth });

        this.ghm_scrollBarPadding = scrollBarWidth > 0 ? 0 : 15;
      }, 500);

    },
    data: function () {
      return {
        isMobile: false,
        ghm_scrollBarPadding: 0,
      };
    },
    computed: {
      gridPageStyle() {
        return {
          paddingRight: `${this.ghm_scrollBarPadding}px`,
        }
      }
    },
    methods: {
      gdi: function (id) {
        // return this.layout.find(e => e.i == id);
        return createGridItemGetter(this[layoutName])(id);
      },
      dynamicHeight: dynamicNTableBoxHeight,
      dBoxDynamicHeight: (e, max) => dynamicNTableBoxHeight(e, {
        nTableRowMaxLength: max
      }),
      dboxTextAreaDynamicHeight: (e) => e > 0 ? { h: 28 } : { h: 15.75 },
      dBoxListDynamicHeight: (
        e,
        max = DEFAULT_MAX_ROW,
        min = DEFAULT_MIN_ROW,
        rowHeight = DEFAULT_ROW_HEIGHT,
        footerHeight = DEFAULT_DBOX_FOOTER_HEIGHT,
        verticalOffset = DEFAULT_VERTICAL_OFFSET
      ) => dynamicNTableBoxHeight(e, {
        nTableHeaderHeight: 0,
        nTableRowMaxLength: max,
        nTableRowMinLength: min,
        nTableRowHeight: rowHeight,
        dboxFooterHeight: footerHeight,
        verticalOffset,
      }),
      conditionalGridMap: function (gridLayout, itemMap = {}) {
        // console.log({ "conditionalGridMap": 1 });
        if (Object.keys(itemMap) == 0) {
          throw Error("Do not use conditionalGridMap function if the Map Object is Empty. Or Provide Condition Mapper Object like this - {key: boolean/newGridItem} in the Second Argument.")
        }

        // console.log({ "this.$refs[gridRef]": this.$refs[gridRef] });

        // console.log({ "gridComponent": gridComponent });

        // console.log({ "conditionalGridMap": 1 });
        // const tempLayoutArray = gridLayout.layout.slice();

        // Object.keys(itemMap).map(gridKey => {
        //   const exist = itemMap[gridKey];
        //   if (!exist) {
        //     tempLayoutArray = tempLayoutArray.filter(e => e.i != gridKey);
        //   }
        //   if (exist && exist.i) {
        //     return 
        //   }
        // });

        // const layout = gridLayout?.layout || [];
        const layout = gridLayout?.layout || [];

        const tempLayoutArray = layout.map(gridItem => {
          const exist = itemMap[gridItem.i];

          if (exist === false) {
            return false;
          }

          if (exist && Object.keys(exist)?.length > 0) {
            // delete exist.y;
            return {
              ...gridItem,
              ...exist,
            }
          } else if (exist && typeof exist === 'number') { // If the Passed in Value is OF Type Number - then DynamicHeight Method will be called
            return {
              ...gridItem,
              ...dynamicNTableBoxHeight(exist || 1),
            }
          }

          return gridItem;
        }).filter(e => e);

        // console.log({ "tempLayoutArray": tempLayoutArray });

        return {
          ...gridLayout,
          layout: tempLayoutArray,
        };
      },
      selectBox: function (title) {
        // console.log(title, layoutName, this[layoutName]);

        SELECT_BOX(this, {
          layoutName,
          title
        });
      },
      onMinimize: function (title) {
        MINIMIZE_BOX(this, {
          layoutName,
          title
        });
        this.$refs.gridLayout.resizeEvent('resizeend');
      },
      onMaximize: function (title) {
        MAXIMIZE_BOX(this, {
          layoutName,
          title
        });
        this.$refs.gridLayout.resizeEvent('resizeend');
      },
      onBoxPinned: function ({ element, title }) {
        PIN_BOX(this, {
          layoutName: layoutName,
          title,
          element
        });
      },

      // Responsive handlers

      windowResizeHandler: function () {
        const width = window.innerWidth;
        const height = window.innerHeight;

        if (window.matchMedia(matchMobile).matches) {
          if (this.isMobile !== true) {
            this.toggleMobileLayout();
            this.isMobile = true;
          }
        } else {

          if (this.isMobile !== false) {
            this.isMobile = false;
            this.toggleNormalLayout();
          }

        }
      },
      toggleMobileLayout: function () {
        this[layoutName].layout.forEach(l => {
          l.w = 60;
        });
        this.$refs[gridRef].resizeEvent('resizeend');
      },
      toggleNormalLayout: function () {
        this[layoutName].layout.forEach(l => {
          l.w = l.origW;
        });
        this.$refs[gridRef].resizeEvent('resizeend');
      },
      // @layout-updated="layoutUpdatedEvent"
      // layoutUpdatedEvent(event) {
      //   console.log({ "layoutUpdatedEvent": event });
      //   this.syncedGridLayoutArray = event;
      // }
    },
  };
}


/** Host for Multiple Grid - Single Grid Per Page (SGPP) */
export const createMultiGridHostSGPP = ({
  layoutName = 'layoutName',
  gridRef = 'layoutName'
} = {}) => {
  return {
    components: {
      ...GridHostComponents
    },
    mounted: function () {
      // window.onresize = this.windowResizeHandler;
    },
    data: function () {
      return {
        isMobile: false,
      };
    },
    methods: {
      gdi: function (id) {
        return createGridItemGetter(this[this.layoutName])(id);
      },
      selectBox: function (title) {
        SELECT_BOX(this, {
          layoutName: this.layoutName,
          title
        });
      },
      onMinimize: function (title) {
        MINIMIZE_BOX(this, {
          layoutName: this.layoutName,
          title
        });
        this.$refs.gridLayout.resizeEvent('resizeend');
      },
      onMaximize: function (title) {
        MAXIMIZE_BOX(this, {
          layoutName: this.layoutName,
          title
        });
        this.$refs.gridLayout.resizeEvent('resizeend');
      },
      onBoxPinned: function ({ element, title }) {
        PIN_BOX(this, {
          layoutName: this.layoutName,
          title,
          element
        });
      },

      // Responsive handlers

      windowResizeHandler: function () {
        const width = window.innerWidth;
        const height = window.innerHeight;

        if (window.matchMedia(matchMobile).matches) {
          if (this.isMobile !== true) {
            this.toggleMobileLayout();
            this.isMobile = true;
          }
        } else {

          if (this.isMobile !== false) {
            this.isMobile = false;
            this.toggleNormalLayout();
          }

        }
      },
      toggleMobileLayout: function () {
        this[this.layoutName].layout.forEach(l => {
          l.w = 60;
        });
        this.$refs[gridRef].resizeEvent('resizeend');
      },
      toggleNormalLayout: function () {
        this[this.layoutName].layout.forEach(l => {
          l.w = l.origW;
        });
        this.$refs[gridRef].resizeEvent('resizeend');
      },
    },
  };
}


// export const dynamicBoxHeight = (array, maxLength = 10) => {
//   return {
//     h: 1.666 * array.length + 6.3
//   }
// }

export const DEFAULT_ROW_HEIGHT = 28;
export const DEFAULT_MAX_ROW = 15;
export const DEFAULT_MIN_ROW = 1;
export const DEFAULT_DBOX_FOOTER_HEIGHT = 36;
export const DEFAULT_VERTICAL_OFFSET = 7;

export const dynamicNTableBoxHeight = (
  nTableRowLength = 2,
  {
    nTableRowMinLength = 1,
    nTableRowMaxLength = 10,
    nTableRowHeight = DEFAULT_ROW_HEIGHT,
    nTableHeaderHeight = 31,
    dBoxFooterHeight = DEFAULT_DBOX_FOOTER_HEIGHT,
    verticalOffset = DEFAULT_VERTICAL_OFFSET,
  } = {}
) => {
  if (!(nTableRowLength >= nTableRowMinLength)) {
    nTableRowLength = nTableRowMinLength;
  }

  if (nTableRowLength > nTableRowMaxLength) {
    nTableRowLength = nTableRowMaxLength;
  }

  return {
    h: ((nTableRowHeight * (nTableRowLength + 1) + nTableHeaderHeight + dBoxFooterHeight + verticalOffset) + 10) / 16
  };
}